export const transformRequestCreateSeelIntegration = ({ storeId, type, fulfillmentTrigger }) => {
  return {
    storeId,
    integration: {
      type,
      configuration: { fulfillment_trigger: fulfillmentTrigger },
    },
  }
}

export const transformResponseCreateSeelIntegration = response => {
  return {
    websocket_url: response.websocket_url,
  }
}

const mapIntegrationInstallStatus = integration => {
  return {
    type: integration.type,
    status: integration.status,
    websocket_url: integration.websocket_url,
  }
}

export const transformResponseIntegrationsInstallStatus = response => response.results.map(mapIntegrationInstallStatus)
